"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
function ToggleThemeMenu({ themeName, toggleTheme, t, className, style, size, }) {
    return react_1.default.createElement("div", { className: className || undefined, style: style || undefined },
        react_1.default.createElement(material_1.Tooltip, { title: t('ra_Change color theme') },
            react_1.default.createElement(material_1.IconButton, { onClick: () => toggleTheme(), size: size || 'medium' },
                themeName === 'dark' && react_1.default.createElement(icons_material_1.Brightness4, { className: className }),
                themeName === 'blue' && react_1.default.createElement(icons_material_1.Brightness5, { className: className }),
                themeName === 'colored' && react_1.default.createElement(icons_material_1.Brightness6, { className: className }),
                themeName !== 'dark' && themeName !== 'blue' && themeName !== 'colored' && react_1.default.createElement(icons_material_1.Brightness7, { className: className }))));
}
exports.default = ToggleThemeMenu;
